import React, { useEffect, useState } from "react";
import { FaBars, FaBell, FaSearch, FaUserCircle } from "react-icons/fa";
import "./Header.css";

const Header = ({ toggleSidebar }) => {
  const [userName, setUserName] = useState("Super Admin");

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem("super_admin_user");

      if (storedUser) {
        const userData = JSON.parse(storedUser);
        setUserName(userData?.full_name || "Super Admin");

        // Set page title
        document.title = `${userData?.full_name || "Super Admin"} (SuperAdmin)`;
      } else {
        document.title = "A2Z";
      }
    } catch (error) {
      console.error("Error reading localStorage:", error);
    }
  }, []);
 


  return (
    <header className="ta-header">
      <div className="ta-header-left">
       

        {/* <div className="ta-search-box">
          <FaSearch className="ta-search-icon" />
          <input
            type="text"
            placeholder="Search..."
            className="ta-search-input"
          />
        </div> */}
      </div>

      <div className="ta-header-right">
        {/* <div className="ta-notification-wrapper">
          <button className="ta-notification-btn">
            <FaBell />
            <span className="ta-badge">3</span>
          </button>
        </div> */}

        <div className="ta-user-profile">
          <FaUserCircle className="ta-user-icon" />
          <span className="ta-user-name">{userName}</span>
        </div>
      </div>
    </header>
  );
};

export default Header;